import { AuthLayout } from "../layouts/AuthLayout";
import urlImage from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { Button, TextInput } from "@tremor/react";
import { useState } from "react";
// import { validateEmail, validatePassword } from "../../helpers/validators";
import Swal from "sweetalert2";
import { adminAPI } from "../../api/adminAPI";
import { useDispatch } from "react-redux";
import { login } from "../../store/auth";
import { useForm } from "react-hook-form";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000,
});

export const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const submitForm = async (form) => {
    const response = await adminAPI
      .post("/auth/login", form)
      .catch(({ response }) => response);
    const { data } = response;
    if (response.status !== 200) {
      Toast.fire({
        icon: "error",
        title: data.message ?? data.data.errors[0].message,
      });
      return;
    }

    localStorage.setItem("x-token", data.data);
    dispatch(login(data.data));
    navigate("/admin/");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      submitForm(e);
    }
  };
  return (
    <AuthLayout>
      <img className="w-50 mx-auto rounded-md" src={urlImage}></img>
      <p className="text-3xl my-3 text-center">Iniciar Sesión</p>
      <form onSubmit={handleSubmit(submitForm)}>
        <div className="mb-2">
          <TextInput
            type="email"
            name="email"
            className="rounded "
            placeholder="email@email.com"
            required
            onKeyUp={handleKeyDown}
            {...register("email", {
              required: {
                value: true,
                message: "Email es requerido",
              },
              minLength: {
                value: 5,
                message: "Email debe tener al menos 5 caracteres",
              },
              pattern: {
                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                message: "Email no es valido",
              },
            })}
          />
          {errors?.email && (
            <span className="text-red-500 text-sm italic">
              {errors?.email?.message}
            </span>
          )}
        </div>
        <div className="mb-2">
          <TextInput
            type="password"
            name="password"
            placeholder="123456"
            required
            onKeyUp={handleKeyDown}
            {...register("password", {
              required: {
                value: true,
                message: "Password es requerido",
              },
              minLength: {
                value: 3,
                message: "Password debe tener al menos 4 caracteres",
              },
            })}
          />
          {errors?.password && (
            <span className="text-red-500 text-sm italic">
              {errors?.password?.message}
            </span>
          )}
        </div>
        <div className="flex justify-between">
          <span className="underline text-center my-3">
            <Link to="/auth/recovery-pass">¿Olvidó su Contraseña?</Link>
          </span>
          <div>
            <Button className="bg-button-main rounded w-min w-m " type="submit">
              Entrar
            </Button>
          </div>
        </div>
      </form>
    </AuthLayout>
  );
};
//
